import { render, staticRenderFns } from "./LoadingPage.vue?vue&type=template&id=a5ea3f7e&scoped=true&"
import script from "./LoadingPage.vue?vue&type=script&lang=ts&"
export * from "./LoadingPage.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingPage.vue?vue&type=style&index=0&id=a5ea3f7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ea3f7e",
  null
  
)

export default component.exports